export const DASHBOARD_GET_STATS = "dashboard/getStats";
export const DASHBOARD_GET_REPORTS = "dashboard/getReports";
export const DASHBOARD_GET_CHATS = "dashboard/getChats";
export const CHATBOT_CHATS = "dashboard/getChats";